import React from 'react'
import Results, { LinkifiedCopy } from './Results'
import Avatar from '.././Avatar'
import { useIsDesktop } from '../../../hooks/useMediaQuery'
import { useTranslation } from '../../../hooks/useTranslation'
import { useMultipleChoiceQuizScore } from '../../JobSearchQuiz/useScoreCalculator'
import { useQuiz } from '.././QuizProvider'

const PersonalBrandQuizResults = () => {
  const {
    formattedQuizName,
    resultsPageAvatar,
    trackContent,
    quizName,
    soloPlusOrAbove,
  } = useQuiz()
  const avatar = resultsPageAvatar
  const isDesktop = useIsDesktop()
  const { t } = useTranslation(formattedQuizName)

  const link1 = t('resource_links.building_a_personal_brand')
  const link2 = t('resource_links.personal_branding_in_digital_age')

  const linkMap = {
    1: link1,
    2: link1,
    3: link2,
    4: link1,
  }

  const breakPoints = [7, 4, 2]
  const [scoreSection, score] = useMultipleChoiceQuizScore(
    trackContent,
    t('questions'),
    breakPoints,
  )

  const header = t(`results.${scoreSection}.header`)
  const platformName = useQuiz().platformName
  const copy =
    scoreSection === 4 && !soloPlusOrAbove
      ? t(`results.${scoreSection}.copy_without_coach`, { score })
      : scoreSection === 4 && platformName[0].toLowerCase().match(/[aeiou]/)
        ? t(`results.${scoreSection}.vowel_copy`, { score })
        : t(`results.${scoreSection}.copy`, { score })

  const linkText = linkMap[scoreSection]

  const link = {
    linkPath: '/personal_brand/resources/article/building-personal-brand',
    linkText: linkText,
  }

  for (let i = 0; i < copy.length; i++) {
    copy[i] = copy[i].replace('[PLATFORM_NAME]', platformName)
  }

  return (
    quizName === 'Personal Brand Iq' && (
      <Results>
        <div className="flex pb-6 sm:justify-around">
          <div className="mt-1 flex h-96 flex-col gap-4 sm:w-9/12">
            {scoreSection !== 4 && <h1 className="!text-[23px]">{header}</h1>}
            <h2>{t(`results.score`, { score })}</h2>
            <div className="mt-4">
              {copy.map((copy, idx) => (
                <LinkifiedCopy key={`copy-${idx}`} copy={copy} link={link} />
              ))}
              <p>{t(`results.congrats`)}</p>
            </div>
          </div>
          {isDesktop && <Avatar src={avatar} />}
        </div>
      </Results>
    )
  )
}

export default PersonalBrandQuizResults
